<script>
  import { Router, Link, Route, link, navigate } from "svelte-routing";
  import { onMount } from "svelte";

  const user = localStorage.getItem("us");

  onMount(() => {
    window.scrollTo(0, 0);
    if (user === null || user === "") {
      navigate("/login");
    }
  });
</script>

<svelte:head>
  <title>Shipping Policy | Veeranfashions</title>
</svelte:head>

<main class="main-wrapper">
  <!-- ...:::Start User Event Section:::... -->
  <div class="header-section">
    <div class="container">
      <!-- Start User Event Area -->
      <div class="header-area">
        <div class="header-top-area header-top-area--style-1">
          <ul class="event-list">
            <li class="list-item">
              <span
                onclick="goback()"
                area-label="mobile menu offcanvas svg icon"
                class="btn btn--size-33-33 btn--center btn--round btn--color-radical-red btn--bg-white btn--box-shadow main-menu offcanvas-toggle offside-menu"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-caret-left-fill"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z"
                  />
                </svg>
              </span>
            </li>
            <li class="list-item">
              <h6 class="title text-center">Shipping Policy</h6>
            </li>
            <li class="list-item">
              <ul class="list-child">
                <li class="list-item">
                  <span class="notch-bg" />

                  <Link
                    to="cart"
                    area-label="Cart"
                    class="btn btn--size-33-33 btn--center btn--round btn--color-radical-red btn--bg-white btn--box-shadow"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-cart-fill"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                      />
                    </svg>
                  </Link>
                </li>
                <li class="list-item">
                  <span class="notch-bg" />
                  <Link
                    to="settings"
                    area-label="Cart"
                    class="btn btn--size-33-33 btn--center btn--round btn--color-radical-red btn--bg-white btn--box-shadow"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-person-fill"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                      />
                    </svg>
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <!-- End User Event Area -->
    </div>
  </div>
  <!-- ...:::End User Event Section:::... -->

  <!-- ...:::Start Whishlist Section:::... -->
  <div class="cart-section section-gap-top-30">
    <div class="container">
      <div class="cart-items-wrapper">
        <!-- Start Single Cart Item -->
        <div class="product-wrapper glass glass_bg">
          <div class="product-wrapper-content--4">
            <!-- Start Product Single Item -->
            <div class="single-product-item product-item--style-4">
              <div class="content">
                <div class="content--left">
                  <article class="container">
                    <div class="row justify-content-center">
                      <div
                        class="col-12 col-lg-12 p-4 bg-custom-animation2 text-color-white rounded"
                      >
                        <div>
                          <p class="text-justify">
                            All orders, once shipped, generally gets delivered
                            within 1 to 4 business days in metros, and within 4
                            to 7 business days for the rest of India, though the
                            delivery time may vary depending upon certain
                            shipping addresses and other factors such as public
                            holidays, political events, extreme weather
                            conditions, and other unavoidable conditions. etc.<br
                            /><br />
                            Please note that owing to the current situation prevailing
                            due to Covid-19, and the impact it had created in the
                            world, the shipments of your orders might get delayed.<br
                            /><br />
                            Damaged product which is opened already while returning
                            the product is acceptable.<br /><br />
                            You can track your orders by using the courier tracking
                            number that you will receive after your order gets confirmed.<br
                            /><br />
                            We always perform a Pre-Shipment Inspection on all orders
                            before packaging it and finally handing over to the Courier
                            Company. This is done in order to check the final product
                            before sending it to you.<br /><br />
                            In the scenario where you have to return a product, we
                            feel sorry to inform you that unfortunately, we do not
                            have any reverse pickup facility as of now; hence, you
                            are humbly requested to send the product(s) to us using
                            any reliable courier service, or by speed post to the
                            address, which will be mentioned in the confirmation
                            email. It is recommended to use Govt. of India Speed
                            Post as it has the most largely distributed postal network
                            across India.<br /><br />
                            In case you receive an item with manufacturing defect
                            and you want to return it following our Return Policy
                            and Shipping Policy, once we get the return of such item,
                            if every condition is met by you following our Return/Refund/Cancellation/Shipping
                            policies, an amount of ₹60/- for the return shipment
                            will be adjusted/refunded. However, for products without
                            any manufacturing defect or fault from our end, we are
                            NOT entitled to bear the return shipping charges.<br
                            /><br />
                            Our courier partners will generally make 6 steps delivery
                            intimation to you over a series of IVR calls, WhatsApp
                            messaging, text messaging, and manual phone call to ensure
                            delivery in case of failed attempts due to wrong shipping
                            address, your unavailability at the location, incorrect
                            mobile number, fake delivery remark and other reasons
                            before marking it as NDR (Non-delivery Report).<br
                            /><br />
                            So, we do request you to kindly ensure to enter correct
                            contact number, name, email address, and postal/delivery
                            address during placing your order. Also we request you
                            to please be present at your location during delivery
                            of the shipment. This will, in return, ensure an efficient
                            and a perfect delivery every time you place an order
                            with us.<br /><br />
                            Shipping Concern according to the Below Company :<br
                            />
                          </p>
                          <ul>
                            <b>VEERAN ENTERPRISE</b><br />
                            80/1 T.PET ROAD<br />
                            NEAR L.G HOSPITAL<br />
                            MUSIRI (po) &amp; (TK)<br />
                            TRICHY (DT)<br />
                            Pincode 621211.<br />
                          </ul>
                          <p />
                        </div>
                      </div>
                    </div>
                  </article>
                </div>
              </div>
              <a href="#?" aria-label="Cart" class="cart-link"
                ><i class="icon icon-carce-x-circle" /></a
              >
            </div>
            <!-- ENd Product Single Item -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ...:::End Whishlist Section:::... -->

  <!-- ...:::Start User Event Section:::... -->
  <div class="user-event-section">
    <!-- Start User Event Area -->
    <div class="col pos-relative">
      <div class="user-event-area">
        <div class="nav">
          <Link to="/" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-house-fill"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6zm5-.793V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"
              />
              <path
                fill-rule="evenodd"
                d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"
              />
            </svg>
            <br />
            <h6>Home</h6>
          </Link>
          <Link to="/wishlist" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-heart-fill"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"
              />
            </svg>
            <br />
            <h6>Wishlist</h6>
          </Link>
          <Link to="/shop" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-grid-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zm8 0A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm-8 8A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm8 0A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3z"
              />
            </svg>
            <br />
            <h6>Shop</h6>
          </Link>
          
          <Link to="/orders" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-box-seam-fill"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M15.528 2.973a.75.75 0 0 1 .472.696v8.662a.75.75 0 0 1-.472.696l-7.25 2.9a.75.75 0 0 1-.557 0l-7.25-2.9A.75.75 0 0 1 0 12.331V3.669a.75.75 0 0 1 .471-.696L7.443.184l.01-.003.268-.108a.75.75 0 0 1 .558 0l.269.108.01.003 6.97 2.789ZM10.404 2 4.25 4.461 1.846 3.5 1 3.839v.4l6.5 2.6v7.922l.5.2.5-.2V6.84l6.5-2.6v-.4l-.846-.339L8 5.961 5.596 5l6.154-2.461L10.404 2Z"
              />
            </svg>
            <br />
            <h6>Orders</h6>
          </Link>
          
          <Link to="/settings" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-gear-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872l-.1-.34zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z"
              />
            </svg>
            <br />
            <h6>Settings</h6>
          </Link>
        </div>
      </div>
    </div>
    <!-- End User Event Area -->
  </div>
  <!-- ...:::End User Event Section:::... -->

  <footer class="footer-section" />
</main>
